<a class="card-link" [href]="data.link" *ngIf="!modeButton">
    <img [src]="data.img" alt="{{ data.text }}">
    <div class="card-link__content">
        <span class="card-link__content--type">{{ data.text }}</span>
        <span class="card-link__content--name">{{ data.name }}</span>
    </div>
</a>

<button mat-flat-button
    *ngIf="modeButton"
    class="mat-elevation-z"
    (click)="goToLink(data.link)"
    color="primary">
    {{ 'Acceder au manager' | transloco}}
</button>
